import { CreditCard } from "lucide-react";

export default function NewTransactionButton({ currentTransaction, step, onReset }) {
  const isCompleted = currentTransaction?.status === 'FULFILLED' || currentTransaction?.status === 'CANCELLED';
  
  // Don't show on step 4 (summary step has its own button)
  if (!isCompleted || step === 4) return null;

  return (
    <div className="theme-card rounded-lg p-4 md:p-6 text-center">
      <button
        onClick={onReset}
        className="theme-button-gradient px-6 py-3 rounded-lg flex items-center justify-center space-x-2 mx-auto"
      >
        <CreditCard className="h-5 w-5" />
        <span>Start New Transaction</span>
      </button>
    </div>
  );
}